import React, { useState } from "react";
import logo from "../assets/logo-b.png";
import { Link, useLocation } from "react-router-dom"; // Asume que estás usando react-router para la navegación
import "../style/TopBar.css";

function TopBarHeader() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const toggleNav = () => setIsNavVisible(!isNavVisible);
  const location = useLocation();

  return (
    <header className="app-header-topbar">
      
      <Link to="/">
        <img src={logo} alt="Logo" className="app-logo-topbar" />
      </Link>

      <button className="hamburger" onClick={toggleNav}>
        {/* Ícono de menú hamburguesa (puedes usar un SVG o un caracter especial) */}
        &#9776;
      </button>
      <nav className={`nav-container-topbar ${isNavVisible ? "visible" : ""}`}>
        <Link
          to="/generador-documentos"
          className={`nav-link-topbar ${
            location.pathname === "/generador-documentos" ? "active" : ""
          }`}
        >
          Generador de Documentos
        </Link>
        <Link
          to="/lector-cedulas"
          className={`nav-link-topbar ${
            location.pathname === "/lector-cedulas" ? "active" : ""
          }`}
        >
          Cédula de Identidad
        </Link>
        <Link
          to="/asistencia-voucher"
          className={`nav-link-topbar ${
            location.pathname === "/asistencia-voucher" ? "active" : ""
          }`}
        >
          Voucher de Asistencia
        </Link>
        <Link
          to="/asistencia-libro"
          className={`nav-link-topbar ${
            location.pathname === "/asistencia-libro" ? "active" : ""
          }`}
        >
          Libro de Asistencia
        </Link>
        <Link
          to="/registros-dt"
          className={`nav-link-topbar ${
            location.pathname === "/registros-dt" ? "active" : ""
          }`}
        >
          Registros DT
        </Link>
        <Link
          to="/afp"
          className={`nav-link-topbar ${
            location.pathname === "/afp" ? "active" : ""
          }`}
        >
          AFP
        </Link>
        <Link
          to="/documentos-trabajadores"
          className={`nav-link-topbar ${
            location.pathname === "/documentos-trabajadores" ? "active" : ""
          }`}
        >
          Documentos Trabajadores
        </Link>
        <Link
          to="/splitter-documental"
          className={`nav-link-topbar ${
            location.pathname === "/splitter-documental" ? "active" : ""
          }`}
        >
          Splitter Documental
        </Link>

      </nav>
    </header>
  );
}

export default TopBarHeader;
